import React, { useMemo } from 'react'
import { tokens } from '../../../styles/desertFloraTheme'

const fmt = (v) => '$' + (v || 0).toLocaleString('en-US', { minimumFractionDigits: 0 })

const barColors = {
  labor: '#3454c1',
  material: '#2f7a3e',
  equipment: '#b35d1a',
  subcontract: '#6e3fb7',
  disposal: '#a9341d'
}

const typeLabels = {
  labor: 'Labor',
  material: 'Material',
  equipment: 'Equipment',
  subcontract: 'Subcontract',
  disposal: 'Disposal'
}

const CostBreakdownPanel = ({ projectService }) => {
  const { breakdown, total } = useMemo(() => {
    const components = projectService?.components || []
    const grouped = {}
    components.forEach((c) => {
      const type = c.costType || 'other'
      if (!grouped[type]) grouped[type] = 0
      grouped[type] += (c.extendedCost || 0)
    })

    const entries = Object.entries(grouped)
      .filter(([, cost]) => cost > 0)
      .map(([type, cost]) => ({ type, cost }))
      .sort((a, b) => b.cost - a.cost)

    const total = entries.reduce((s, e) => s + e.cost, 0)
    return { breakdown: entries, total }
  }, [projectService])

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 8 }}>
        <div style={{
          fontFamily: tokens.fontMono, fontSize: 10.5, fontWeight: 600,
          letterSpacing: '.12em', textTransform: 'uppercase', color: tokens.ink3
        }}>
          Cost breakdown
        </div>
        <span style={{ fontFamily: tokens.fontMono, fontSize: 12, color: tokens.ink3 }}>
          of {fmt(total)}
        </span>
      </div>

      {breakdown.length === 0 ? (
        <div style={{ fontSize: 12, color: tokens.ink4, fontStyle: 'italic' }}>
          No costs yet.
        </div>
      ) : (
        breakdown.map((entry) => {
          const pct = total > 0 ? (entry.cost / total) * 100 : 0
          return (
            <div
              key={entry.type}
              style={{
                display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0'
              }}
            >
              <span style={{
                fontSize: 12, color: tokens.ink2,
                width: 80, flexShrink: 0
              }}>
                {typeLabels[entry.type] || entry.type}
              </span>
              <div style={{
                flex: 1, height: 8,
                background: tokens.bg2,
                borderRadius: 4, overflow: 'hidden'
              }}>
                <div style={{
                  height: '100%', borderRadius: 4,
                  width: `${pct}%`,
                  background: barColors[entry.type] || tokens.ink3
                }} />
              </div>
              <span style={{
                fontFamily: tokens.fontMono, fontSize: 12, color: tokens.ink,
                width: 70, textAlign: 'right', flexShrink: 0
              }}>
                {fmt(entry.cost)}
              </span>
            </div>
          )
        })
      )}
    </div>
  )
}

export default CostBreakdownPanel
